import TeamMember1 from "./img/it.png";
import TeamMember2 from "./img/ladder.png";
import TeamMember3 from "./img/kid.png";
import TeamMember4 from "./img/high.png";
import TeamMember5 from "./img/students.png"



export const team = [
    {
      image: TeamMember1,

      name: "INFORMATION TECHNOLOGY(IT)",
      description:
        "Education is evolving fast. Every day, we hear about some new technology that will change the world and the way we learn.",
        link:"Madhukar Tonpe",
        date:"17th Sept 2016",
        more: "Readmore",  
        herf:"/itBlogs"      
    },
    {
      image: TeamMember2,
      name: "Climbing Up The Ladder Of Success",
      description:
        "Guru Harkrishan High School & Junior College believes in enlightening and educating children in a stress",
        link:"Sarita Colvalkar",
        date:"17th Sept 2016",
        more: "Readmore",
        herf:"/climbingBlogs"
    },
    {
      image: TeamMember3,
      name: "Guru Harkrishan High School - Pre-Primary Section",
      
      description:
        "My team i.e. the staff of my school is very friendly, warm and affectionate. We always encourage our ",
        link:"Sangeeta Sharma",
        date:"17th Sept 2016",
        more: "Readmore",
        herf:"/preBlogs"
    },
    {
        image: TeamMember4,
        name: "ALWAYS AIM HIGHER",
        
        description:
          "We try our best to inculcate good habits in our students, i.e. punctuality, obedience, respect for elders, dutifulness, diligence in",
          link:"Mrs. Minoo Kalra",
          date:"17th Sept 2016",
          more: "Readmore",
          herf:"/aimBlogs"
      },
      {
        image: TeamMember5,
        name: "Jr. College",
        description:
          "This is a brief note to let you know how committed, I am to make this junior college of commerce a good Institution.",
          link:"Shyama Dubey",
          date:"17th Sept 2016",
          more: "Readmore",
          herf:"/jrBlogs"
      },
      
  ];
  
